import Image from '@/models/image';
import assetsUtils from '@/utils/url.utils';

export default class TransactionStorehousePlace {
  public id: string;
  public name: string;
  public address: string;
  public image: Image = new Image();

  public constructor(transactionStorehousePlaceProps: any) {
    this.id = transactionStorehousePlaceProps.id;
    this.name = transactionStorehousePlaceProps.name;
    this.address = transactionStorehousePlaceProps.address;

    if (transactionStorehousePlaceProps.image) {
      this.image = new Image(transactionStorehousePlaceProps.image);
    }
  }

  get preview(): URL {
    if (this.image.original && this.image.path) {
      return assetsUtils.generateAssetsUrl(this.image.path);
    }

    return require('../assets/images/header-logo.png');
  }
}
